import api from '../../helpers/axios'

export const state = {
    sale: null,
    sales: []
};

export const getters = {
    sale: (state) => state.sale,
    sales: (state) => state.sales,
};

export const mutations = {
    setSale(state, newValue) {
        state.sale = newValue;
    },
    setSales(state, newValue) {
        state.sale = newValue;
    },
};

export const actions = {

    fetchSales({commit}, {site, name, field, isActive, page, limit, listType}) {
        let query = "?";

        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }

        if (site) {
            query += `site=${site}&`;
        }
        if (name) {
            query += `name=${name}&`;
        }
        if (field) {
            query += `field=${field}&`;
        }

        if (isActive !== undefined) {
            query += `isActive=${isActive}&`;
        }
        //todo: res.data.data olacak, axios değil api olacak
        return new Promise((resolve) => {
            api.get("orders" + query).then((res) => {
                commit("setSales", res.data);
                resolve(res.data);
            });
        });
    },
};
